
const digest = '3a8651f3245f8ee3f7d662552188c794054262b58797140bddc679f1256eeb33';
const classes = {"wrapper":"_wrapper_739hr_1","baseImage":"_baseImage_739hr_5","card":"_card_739hr_9","icon":"_icon_739hr_24","header":"_header_739hr_28","normal":"_normal_739hr_33"};
const css = `._wrapper_739hr_1 {
  position: relative;
  width: 100%;
}
._wrapper_739hr_1 ._baseImage_739hr_5 {
  width: 100%;
  z-index: -1;
}
._wrapper_739hr_1 ._card_739hr_9 {
  border-radius: 15px;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin: -40px 5% 0 5%;
  z-index: 1;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 20px 20px 20px;
  text-align: center;
  position: relative;
}
._wrapper_739hr_1 ._card_739hr_9 ._icon_739hr_24 {
  position: absolute;
  top: -45px;
}
._wrapper_739hr_1 ._card_739hr_9 ._header_739hr_28 {
  color: #3C3F9C;
  font-weight: 600;
  font-size: 16px;
}
._wrapper_739hr_1 ._card_739hr_9 ._normal_739hr_33 {
  color: #3C3F9C;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  